import { Box } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  api_request,
  setCommonReducer,
} from "../../store/actions/commonAction";
import {
  API_METHOD_GET,
  API_METHOD_POST,
  multiDocument,
} from "../../config/constants";
import {
  BILL_UPLOAD_ERROR,
  BILL_UPLOAD_SUCCESS,
} from "../../store/types/billTypes";
import { setBillReducer } from "../../store/actions/billActions";
import { useLocation, useNavigate } from "react-router";
import {
  FORBIDDEN_ACTION,
  GET_BASIC_ERROR,
  GET_BASIC_SUCCESS,
  UNAUTHORIZED_USER,
} from "../../store/types/authTypes";
import { theme } from "../../config/theme";
import Swal from "sweetalert2";
import CoreFileUploader from "../../core/inputs/CoreFileUploader";
import CoreModal from "../../core/layouts/CoreModal";
import CoreLinearProgress from "../../core/Loader/CoreLinearProgress";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import { getApiHeader } from "../../helper/apiActionHelper";
import { backendUrl } from "../../config/api";

export default function MarutiDocUpload() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const tool = location.pathname.split("/")[1];

  const [file, setFile] = useState(null);
  const [description, setDescription] = useState(null);
  const [uploadModal, setUploadModal] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [tempData, setTempData] = useState(null);
  const [isMulti, setMulti] = useState(false);

  const auth = useSelector((state) => state?.auth);
  const billUploadSuccess = useSelector(
    (state) => state?.bill?.billUploadSuccess,
  );
  const billUploadError = useSelector((state) => state?.bill?.billUploadError);
  const billUploadMessage = useSelector(
    (state) => state?.bill?.billUploadMessage,
  );
  const billUploadData = useSelector((state) => state?.bill?.billUploadData);
  const submitBillSuccess = useSelector(
    (state) => state?.bill?.submitBillSuccess,
  );
  const submitBillError = useSelector((state) => state?.bill?.submitBillError);
  const submitBillMessage = useSelector(
    (state) => state?.bill?.submitBillMessage,
  );
  const docTypes = useSelector((state) => state.common.toolDocTypes);
  const appSettings = useSelector((state) => state?.common?.appSettings);
  const uploadMultiple = appSettings?.find((set) => set.name === multiDocument)
    ? appSettings?.find((set) => set.name === multiDocument)?.value?.enabled
    : false;

  useEffect(() => {
    if (file) {
      handleZipUpload();
    }
  }, [file]);

  useEffect(() => {
    if (billUploadSuccess) {
      dispatch(
        api_request(
          API_METHOD_GET,
          "/business/individual/ProfileBasic",
          {},
          {
            _defaultFilter: encodeURIComponent(
              JSON.stringify({ userId: auth?.uid }),
            ),
          },
          null,
          GET_BASIC_SUCCESS,
          GET_BASIC_ERROR,
          true,
          false,
        ),
      );
      // alert(billUploadMessage);
      if (
        billUploadData?.docId ||
        tool === "tender-management" ||
        tool === "pricebook-management"
      ) {
        dispatch(
          setBillReducer({
            billUploadSuccess: false,
            docId: billUploadData.docId,
            docType: billUploadData.Type,
          }),
        );
        if (billUploadData.docId) {
          navigate("/" + tool + "/single");
        } else {
          navigate("/" + tool + "/unsaved/single");
        }
      } else {
        let uniqueId = billUploadData?.uniqueId;
        dispatch(
          setBillReducer({
            billUploadSuccess: false,
            billUploadData: null,
            jobBillsData: null,
          }),
        );
        Swal.fire({
          title: "Processing Started, ID:" + uniqueId,
          text: "You will be notified via email once done",
          icon: "success",
          confirmButtonColor: theme.palette.primary.main,
        });
        navigate("/" + tool + "/docs/view");
      }
    }
    if (billUploadError) {
      alert(billUploadMessage);
      dispatch(setBillReducer({ billUploadError: false }));
    }
  }, [billUploadSuccess, billUploadError]);

  useEffect(() => {
    if (submitBillSuccess) {
      alert(submitBillMessage);
      dispatch(setBillReducer({ submitBillSuccess: false }));
    }
    if (submitBillError) {
      alert(submitBillMessage);
      dispatch(setBillReducer({ submitBillError: false }));
    }
  }, [submitBillSuccess, submitBillError]);

  const handleZipUpload = (e) => {
    e?.preventDefault();

    let requestBody = {
      file: file,
      tool: tool,
    };
    console.log("file upload ", file, requestBody);
    dispatch(
      api_request(
        API_METHOD_POST,
        "/maruti/doc/upload",
        requestBody,
        {},
        null,
        BILL_UPLOAD_SUCCESS,
        BILL_UPLOAD_ERROR,
        true,
        true,
      ),
    );
  };

  console.log("billUploadData DATA", docTypes);
  return (
    <>
      <div
        style={{
          height: "calc(100vh - 68px - 4px)",
          width: "calc(100% + 32px)",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginLeft: "-8px",
          marginTop: "-8px",
        }}
      >
        <CoreFileUploader
          tool={tool}
          handleChange={(file) => {
            if (file) {
              setFile(file);
            }
          }}
          isMulti={false}
          isMultiChecked={false}
          label="Upload your document zip"
          allowedFiles={["zip"]}
        />
      </div>
    </>
  );
}
